<template>
    <!-- begin:: Page -->
    <div class="page h-screen w-screen">
      <router-view></router-view>
    </div>
    <!-- end:: Page -->
</template>

<script>
// import PageBody from './Body';

export default {
    name: "Page",
    components: {
        // PageBody,
    },
}
</script>

<style scoped>

</style>
